module.exports = __webpack_public_path__ + "static/media/clientBg.71a3221f.webp";